module.exports = __webpack_public_path__ + "img/bgc17.650ec68c.png";